@if (selectedCompany != undefined && selectedCustomer != undefined) {
  <div class="text-justify settlementBreakdownLetter" style="font-family: &quot;Calibri, sans-serif&quot;; line-height: 150%; font-size: 12pt" id="htmlData" #htmlData>
    <div class="d-flex justify-content-center align-items-center">
      <p class="text-center m-0 p-0 addressDiv">{{ selectedCustomer.Address }}</p>
    </div>

    <hr />

    <div class="d-flex justify-content-center align-items-center row">
      <div class="col-12">
        <p class="text-center m-0 p-0">
          <strong>{{ selectedCompany.Name }}</strong>
        </p>
      </div>

      <div class="addressDiv">
        <p class="text-center m-0 p-0">{{ selectedCompany.Address }}</p>
      </div>
    </div>

    <br />
    <br />
    <p class="d-flex justify-content-end">{{ sharedService.getTodayDate() | date: "dd-MM-yyyy" }}</p>

    <p>Tuan,</p>

    <h5 class="text-center text-decoration-underline"><strong> Surat Memberi Kuasa</strong></h5>

    <p>
      Saya <b>{{ selectedCustomer.Name }} (IC: {{ selectedCustomer.ICNumberWithDash }})</b> memberi kuasa kepada <b>{{ selectedCompany.Name }}</b> untuk "online transfer" semua amaun pinjaman saya dari pihak syarikat ke akaun bank <b>({{ selectedAccount.Bank }} Bank Acc. No.: {{ selectedAccount.AccountNumber }})</b>
      @if (selectedContact != undefined) {
        {{ selectedContact.Relation | lowercase }}
      }
      saya akaun yang bernama <b>{{ selectedAccount.HolderName }}</b
      >.
    </p>

    <br />
    <p>
      Saya memahami bahawa pihak syarikat <b>{{ selectedCompany.Name }}</b> tidak akan menanggung segala kerugian setelah duit pinjaman tersebut telah dipindah.
    </p>

    <p>Sekian.</p>
    <br />
    <p>Yang Benar,</p>
    <br />
    <br />
    <br />
    <br />
    <br />
    <p>{{ selectedCustomer.Name }}</p>
  </div>
}
